var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row light-border p-2", attrs: { id: "status-container" } },
    [
      _c(
        "div",
        { staticClass: "col-5 ml-3" },
        [_c("Allsky", { attrs: { telescope: _vm.telescope } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 ml-auto mr-3" }, [
        _c("div", { staticClass: "row pb-1" }, [
          _c("div", { staticClass: "col" }, [
            _c("strong", [
              _vm._v(
                "You are logged in to observe on the " +
                  _vm._s(_vm.telescope.name)
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "list-group" },
          [
            _c("status-item", {
              attrs: {
                context: _vm.sessionInfo.context,
                "status-key": "Session",
                "status-value": _vm.sessionInfo.value
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row pb-3 pt-2" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "progress", staticStyle: { background: "white" } },
              [
                _c("div", {
                  staticClass: "progress-bar",
                  style: "width:" + _vm.percentComplete + "%",
                  attrs: {
                    role: "progressbar",
                    "aria-valuenow": _vm.percentComplete,
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.minutesRemaining) + " minutes remaining")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "list-group" },
          [
            _c("status-item", {
              attrs: {
                context: _vm.availabilityInfo.context,
                "status-key": "Observatory",
                "status-value": _vm.availabilityInfo.value
              }
            }),
            _vm._v(" "),
            _c("status-item", {
              attrs: {
                context: _vm.telescopeInfo.context,
                "status-key": "Telescope",
                "status-value": _vm.telescopeInfo.value
              }
            }),
            _vm._v(" "),
            _c("status-item", {
              attrs: {
                context: _vm.cameraInfo.context,
                "status-key": "Camera",
                "status-value": _vm.cameraInfo.value,
                "exposure-time": _vm.exposureSecondsLeft
              }
            }),
            _vm._v(" "),
            _c("status-item", {
              attrs: {
                context: _vm.progressInfo.context,
                "status-key": "Progress",
                "status-value": _vm.progressInfo.value
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }